(function () {
  if (window.__heroVideoInit) return;
  window.__heroVideoInit = true;

  function initSection(section) {
    if (!section || section.dataset.hvInit) return;
    section.dataset.hvInit = '1';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      section.querySelectorAll('.video-container[data-video-type]').forEach(function (c) {
        c.removeAttribute('data-video-type');
      });
      return;
    }

    var desktop = section.querySelector('.hero-video__item--desktop');
    var mobile = section.querySelector('.hero-video__item--mobile');
    if (!desktop || !mobile) return;

    var mq = window.matchMedia('(min-width: 768px)');

    function defer(el) {
      if (el && el.getAttribute('data-video-type')) {
        el.setAttribute('data-video-type-deferred', el.getAttribute('data-video-type'));
        el.removeAttribute('data-video-type');
      }
    }

    function activate(el) {
      if (!el || !el.getAttribute('data-video-type-deferred')) return;
      el.setAttribute('data-video-type', el.getAttribute('data-video-type-deferred'));
      el.removeAttribute('data-video-type-deferred');
      if (window.theme && theme.VideoManager && theme.VideoManager.onSectionLoad) {
        theme.VideoManager.onSectionLoad(section);
      }
    }

    defer(mq.matches ? mobile : desktop);

    function sync() {
      activate(mq.matches ? desktop : mobile);
    }

    if (mq.addEventListener) {
      mq.addEventListener('change', sync);
    } else if (mq.addListener) {
      mq.addListener(sync);
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('.hero-video[data-section-type="background-video"]').forEach(initSection);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
